import { render, staticRenderFns } from "./deptDetail.vue?vue&type=template&id=6a117800&scoped=true&"
import script from "./deptDetail.vue?vue&type=script&lang=js&"
export * from "./deptDetail.vue?vue&type=script&lang=js&"
import style0 from "./deptDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./deptDetail.vue?vue&type=style&index=1&id=6a117800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a117800",
  null
  
)

export default component.exports